import Vuex, { Store } from "vuex";
import base, { StateT as BaseState } from "./base";
import leadsView, { StateT as LeadsViewState } from "./leadsView";

type State = {
  base: BaseState;
  leadsView: LeadsViewState;
};

const store = new Vuex.Store<State>({
  modules: {
    base,
    leadsView,
  },
});

export type StoreInstance = Store<State>;
export default store;
